import _ from "lodash";
import { mapGetters } from "vuex";

import * as k4util from "@/utils/k4util";

export default {
	props: {
		node: { type: Object, required: true },
		subpath: { type: String, required: false, default: "" },
	},

	computed: {
		...mapGetters({
			liveNodeByGuid: "controller/nodes/liveNodeByGuid",
			liveNodeByPath: "controller/nodes/liveNodeByPath",
		}),

		meta() {
			// Prop/Var subpaths are external to meta, but we need to account
			// for command arg subpaths which point into meta.
			const subpath = _.startsWith(this.subpath, "meta/")
				? this.subpath
				: _.compact(["meta", this.subpath]).join("/");
			return _.get(this.node, subpath.split("/"));
		},

		nodeName() {
			return _.last(this.subpath.split("/"));
		},

		displayName() {
			const guid = this.node.meta.guid;
			const node = this.liveNodeByGuid(guid).child(this.subpath);
			return k4util.humanizeNodeName(node);
		},

		nodeValue() {
			return _.get(this.node, this.subpath.split("/"));
		},

		displayValue() {
			switch (this.nodeValue) {
				case "":
				case null:
					return "<>";
				case undefined:
					return "";
			}

			if (this.meta.type === "path") {
				// The display *value* for a 'path' type node is the *name* of
				// the referenced node.
				const node = this.liveNodeByPath(this.nodeValue);
				return node ? k4util.humanizeNodeName(node) : "Unknown";
			}

			return this.nodeValue;
		},

		// The type of input field to use for editing this node property.
		inputType() {
			switch (this.meta.type) {
				case "path":
					if (!this.meta.options) break;
					return "path";
				case "boolean":
					return "checkbox";
				case "string":
					if (this.meta.options && this.meta.options.length) return "select";
				// else fall-through
			}
			return "textfield";
		},

		textInputType() {
			switch (this.meta.type) {
				case "number":
					return "number";
				default:
					return "text";
			}
		},

		// Group and class information
		// --------------------------------------------------------------------
		nodeExtends() {
			return _.get(this.meta, "extends", []);
		},

		isLight() {
			return _.includes(this.nodeExtends, k4util.CLS_LIGHT);
		},

		isSensor() {
			return _.includes(this.nodeExtends, k4util.CLS_SENSOR);
		},

		isDimmer() {
			return _.includes(this.nodeExtends, k4util.CLS_DIMMER);
		},

		isMotionDimmer() {
			return this.isDimmer && this.isSensor;
		},

		isMotionSwitch() {
			return this.isLight && this.isSensor && !this.isDimmer;
		},
	},
};
